import { ChangeDetectionStrategy, Component, DestroyRef, HostBinding, OnChanges, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Subject, delay, distinctUntilChanged, iif, map, of, switchMap } from 'rxjs';

import { carouselFactorAnimation } from '../../../animations';
import { AccaBoostCarouselItemComponent } from '../acca-boost-carousel-item/acca-boost-carousel-item.component';

@Component({
    selector: 'bs-acca-boost-carousel-max-boost-item',
    templateUrl: './acca-boost-carousel-max-boost-item.component.html',
    animations: [carouselFactorAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: [
        '../../styles/acca-boost-shared.scss',
        './acca-boost-carousel-max-boost-item.component.scss',
        '../../styles/acca-boost-carousel-item.scss',
    ],
    standalone: false,
})
export class AccaBoostCarouselMaxBoostItemComponent extends AccaBoostCarouselItemComponent implements OnChanges {
    showMaxText = signal(false);
    modelSubject = new Subject<any>();
    private readonly destroyRef = inject(DestroyRef);

    @HostBinding('class') class = 'carousel-item carousel-item__wrapper';

    constructor(sitecore: Sitecore) {
        super(sitecore);

        this.modelSubject
            .pipe(
                map((x) => x.selected),
                switchMap((selected) => iif(() => selected, of(selected).pipe(delay(2000)), of(selected))),
                distinctUntilChanged(),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe((selected) => {
                this.showMaxText.set(selected);
            });
    }

    ngOnChanges() {
        this.modelSubject.next(this.model);
    }
}
